module.exports = __webpack_public_path__ + "static/media/icon_arrow_left.09d6a120.svg";